import script from "./MessagePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessagePreview.vue?vue&type=script&setup=true&lang=ts"

import "./MessagePreview.vue?vue&type=style&index=0&id=5170ccf2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5170ccf2"]])

export default __exports__